'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  expanded: function expanded() {
    return '\n    overflow-x: hidden;\n    overflow-y: auto;\n  ';
  }
};

var styles = function styles() {
  return '\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: ' + (0, _decisivUiUtils.px2rem)(45) + ';\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuBlock', _styledComponents2.default.div, styles, {
  modifierConfig: modifierConfig
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/LeftNav/MenuBlock.js
// module id = 1579
// module chunks = 2